import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import "shared/i18n";
import App from 'components/App';
import store from 'redux/store';

const rootElement = (
  <Provider store={store}>
    <React.Suspense fallback="Loading...">
      <App />
    </React.Suspense>
  </Provider>
);

ReactDOM.render(rootElement, document.getElementById('root'));
